export default __webpack_public_path__ + "static/media/logo-mobile.db8a8067.svg";